import { useAppSelector } from '../redux/store';

export const usePrimaryColors = () => {
	return useAppSelector(state => state.ui.primaryColors);
};
